export default __webpack_public_path__ + "static/media/RichBitch.05d877fa.gif";